export default "/images/vendor/flag-icon-css/flags/4x3/mu.svg?468d5464b2219b1bb9227af74e552fef";